export default "images/bg1.jpg";